import React from "react";
import {Grid, Row} from "react-flexbox-grid";

function GuideText() {
	return (
		<Grid fluid>
			<Row end="xs" className="board-hint">
				<img className="board-hint-icon" src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725713/icon-click_ftzptz.svg" alt="Click" />
				<p className="board-hint-text">
					Click a Star/Film for more info
				</p>
			</Row>
			<Row end="xs" className="board-hint">
				<img className="board-hint-icon" src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725713/icon-drag_pq5zs6.svg"alt=" Drag" />
				<p className="board-hint-text">
					Drag the board or a star/film around
				</p>
			</Row>
			<Row end="xs" className="board-hint">
				<img className="board-hint-icon" src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725713/icon-zoom_ruruew.svg" alt="Zoom" />
				<p className="board-hint-text">Zoom in/out of the board</p>
			</Row>
		</Grid>
	);
}

export default GuideText;
